import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LittleBarsLoaderComponent } from '@upassignations/core';

@Component({
  selector: 'lib-actions-history',
  imports: [CommonModule, LittleBarsLoaderComponent],
  templateUrl: './actions-history.component.html',
  styleUrl: './actions-history.component.scss',
})
export class ActionsHistoryComponent {
  @Input() loadingActionsHistory = false;
  @Input() actionsHistory: { date: string; action: string; auteur: string }[] =
    [];
  @Output() closeSidePanel = new EventEmitter<void>();

  close(): void {
    this.closeSidePanel.emit();
  }
}
